/**
 * Iconify Configuration - Disable CDN and Bundle Icons Locally
 *
 * This configuration prevents Iconify from making any CDN requests,
 * which causes CORS errors in production deployments.
 *
 * Solution: Load icon data from local @iconify-json packages
 */

import { addCollection } from "@iconify/react";

import { logger } from "@/telemetry";

// Import icon data from local packages (will be bundled by Vite)
// These imports are asynchronous to avoid blocking initial load
const loadIconSets = async () => {
  try {
    // Load Solar icons (most used - 110 icons)
    const solar = await import("@iconify-json/solar/icons.json");

    addCollection(solar.default);

    // Load Gravity UI icons (30 icons)
    const gravityUi = await import("@iconify-json/gravity-ui/icons.json");

    addCollection(gravityUi.default);

    // Load Material Design Icons (11 icons)
    const mdi = await import("@iconify-json/mdi/icons.json");

    addCollection(mdi.default);

    // Load IC icons (4 icons)
    const ic = await import("@iconify-json/ic/icons.json");

    addCollection(ic.default);

    // Load Fluent Color icons (1 icon)
    const fluentColor = await import("@iconify-json/fluent-color/icons.json");

    addCollection(fluentColor.default);

    // Load Simple Icons (1 icon)
    const simpleIcons = await import("@iconify-json/simple-icons/icons.json");

    addCollection(simpleIcons.default);

    logger.info("[Iconify] All icon sets loaded from local bundles");
  } catch (error) {
    logger.error("[Iconify] Error loading icon sets", error instanceof Error ? error : undefined);
  }
};

// Start loading icon sets immediately
loadIconSets();

// Disable API providers by setting empty resources array
// This prevents Iconify from trying to fetch from CDN
if (typeof window !== "undefined") {
  // Override the default API config to prevent any CDN requests
  const iconifyConfig = (window as any).__ICONIFY__;

  if (iconifyConfig) {
    iconifyConfig.config = {
      ...iconifyConfig.config,
      resources: [],
    };
  }
}
